import type { NumberedCitation } from "#features/citations/citedContent.ts";
import { useSidePanelStore } from "#stores/useSidePanelStore.ts";
import type { ConversationMessage } from "#types/types.ts";
import { create } from "zustand";

interface SourcesSidePanelStore {
    closeMessageSources: () => void;
    activeMessage: ConversationMessage | null;
    /** The active answer's cited sources with the numbers its pills show, in display order. */
    activeCitations: NumberedCitation[];
    toggleSidePanel: (message: ConversationMessage, citations: NumberedCitation[]) => void;
}

export const useSourcesSidePanelStore = create<SourcesSidePanelStore>(set => ({
    activeMessage: null,
    activeCitations: [],
    closeMessageSources: () => {
        useSidePanelStore.getState().closeSidePanel();
        set({ activeMessage: null, activeCitations: [] });
    },
    toggleSidePanel: (message: ConversationMessage, citations: NumberedCitation[]) => {
        set(state => {
            const { isSidePanelOpen, type, openSidePanel, closeSidePanel } = useSidePanelStore.getState();

            if (!isSidePanelOpen || type !== "sources" || (state.activeMessage && state.activeMessage.id !== message.id)) {
                openSidePanel("sources");

                return { activeMessage: message, activeCitations: citations };
            } else {
                closeSidePanel();

                return { activeMessage: null, activeCitations: [] };
            }
        });
    }
}));
